import { render } from "./MediaLibrary.vue?vue&type=template&id=c70d1c52&scoped=true"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-c70d1c52"

export default script